import React, { Component, Fragment } from "react";
import { observer, inject } from "mobx-react";
import PropTypes from "prop-types";
import MyOrderWrapper from "../../component/MyOrderWrapper";
import ContinueLogin from "../../component/ContinueLogin";
import { setPageType } from "../../utils";
import { Button, Img } from "arv-reactcomponents";
import { pageType, MYORDERS_MESSAGES, Endpoints } from "npmlinks-constants";
import TitleBlock from "../../component/TitleBlock";

@inject("LoginStore")
@observer
class MyOrders extends Component {
  constructor() {
    super();
    this.state = {
      showLoggedOutState: false,
    };
    this.validateLogin = this.validateLogin.bind(this);
  }
  componentDidMount() {
    setPageType(pageType.myOrders);
    this.validateLogin();
    this.setState({ showLoggedOutState: true });
  }

  validateLogin() {
    const { isUserLoggedIn } = this.props.LoginStore;
    if (!isUserLoggedIn) {
      this.props.LoginStore.setloginModal(true);
    }
  }

  render() {
    const { isUserLoggedIn } = this.props.LoginStore;
    const { showLoggedOutState } = this.state;
    return (
      <div className="nw-order-noorderwrapper">
        <TitleBlock.component
          title={MYORDERS_MESSAGES.TITLE}
          className="nw-myorder-title"
        />
        {isUserLoggedIn ? (
          <MyOrderWrapper.component />
        ) : (
          (showLoggedOutState && (
            <ContinueLogin.component altMsg="noOrders" />
          )) ||
          null
        )}
      </div>
    );
  }
}

MyOrders.wrappedComponent.propTypes = {
  LoginStore: PropTypes.shape({
    isUserLoggedIn: PropTypes.bool.isRequired,
    setloginModal: PropTypes.func.isRequired,
  }).isRequired,
};

const getFinalComponent = component =>
  inject("LoginStore")(observer(component));

export const ProjectComponent = {
  getFinalComponent,
  wrapper: MyOrders.wrappedComponent,
  component: MyOrders,
};

export default ProjectComponent.component;
